<section class="m-section">
  <div class="container">
    <div class="content">
      <div class="image" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1000">
        <div class="img">
          <img src="/assets/images/faqs-page.webp" alt="Imagen Seccion Faqs">
          <div class="info">
            <h1 class="title-section">¿Tienes dudas? </h1>
            <h2 class="text">Consulta las preguntas más comunes sobre nuestros servicios y procesos de construcción.</h2>
          </div>
        </div>
      </div>
      <div class="faqs" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000">
        <p-accordion [activeIndex]="null">
          @for (tab of faqs; track $index) {
          <p-accordionTab [ngClass]="{ 'bg-primary': $index % 2 === 0, 'bg-secondary': $index % 2 !== 0 }">
            <ng-template pTemplate="header">
              <div class="custom-header">
                <span>{{ tab.title }}</span>
                <i class="pi pi-plus plus"></i>
              </div>
            </ng-template>
            <div class="info-tab">
              <p class="text">{{ tab.info }}</p>
            </div>
          </p-accordionTab>
          }
        </p-accordion>
      </div>

    </div>
  </div>
</section>
